import React, { useState, useEffect } from 'react'
import axios from 'axios'
import SkillsCards from './SkillsCards'
import { FaArrowCircleDown, FaArrowCircleUp } from 'react-icons/fa'
import '../css/Skills.css'

const Projects = () => {

    const [currentRepos, setCurrentRepos] = useState([])
    const [repos, setRepos] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isShowingAll, setIsShowingAll] = useState(false)


    const showAll = () => {
        setIsLoading(true)
        const post = repos.slice(0, repos.length)
        setIsShowingAll(true)
        setCurrentRepos(post)
        setIsLoading(false)
    }

    const showLess = () => {
        setIsLoading(true)
        const post = repos.slice(0, 3)
        setCurrentRepos(post)
        setIsShowingAll(false)
        setIsLoading(false)
    }

    useEffect(() => {
        setIsLoading(true)
        const getData = async () => {
            const res = await axios.get('https://api.github.com/users/sajjathossain/repos')
            setRepos(res.data)
            setCurrentRepos(res.data.slice(0,3))
            setIsLoading(false)
        }

        getData()
    }, [])

    console.log(repos)


    return (
        <div className="skillsContainer" id="projects">
           <div className="skillsHeader">
               <div className="skillsHeaderText">Projects</div>
           </div>
           <div>
                {
                    isLoading === false ? 
                    <div className="skillsAllCardContainer">
                        <SkillsCards mySkills={currentRepos} />
                    </div> : <div className="alert alert-danger text-center">Loading...</div>
                }
                <div className="d-flex justify-content-center mt-4">
                    {
                        // isShowingAll === false ? <button className="showAllBtn" onClick={showAll}><FaArrowCircleDown /></button> : <button className="showLessBtn" onClick={showLess}><FaArrowCircleUp /></button>
                        isShowingAll === false ? <button className="pr-5 pl-5 border border-dark btn btn-light bg-light text-dark" onClick={showAll} ><FaArrowCircleDown /></button> : <button className="border border-dark btn btn-dark text-light bg-dark pr-5 pl-5" onClick={showLess} ><FaArrowCircleUp /></button>
                    }
                </div>
            </div>
        </div>
    )
}

export default Projects
